import React, { useState } from 'react';
import { usePIM } from '../context/PIMContext';
import { Info } from 'lucide-react';
import AccessoryDetailsModal from './modals/AccessoryDetailsModal';
import { BASE_UPLOAD_URL } from '../config';

const PackageContentsPanel = () => {
    const { components, activeCharge } = usePIM();
    const [selectedAccessory, setSelectedAccessory] = useState(null);

    // Filter components that are accessories AND marked as package content
    const packageContents = components
        .filter(c => c.role === 'accessory' && c.is_package_content);

    return (
        <div className="h-full flex flex-col">
            <h3 className="text-stone-400 font-medium mb-4 flex items-center justify-between">
                <span>Package contents ({activeCharge ? activeCharge.batch_number : 'No Charge'})</span>
            </h3>

            <div className="flex-1 overflow-y-auto space-y-2 pr-2">
                {packageContents.length === 0 ? (
                    <div className="text-stone-600 text-center py-10 italic">
                        No package contents defined.
                    </div>
                ) : (
                    packageContents.map((item) => (
                        <div key={item.id} className="bg-stone-800 rounded p-3 flex items-center justify-between border border-stone-700">
                            <div className="flex items-center gap-3">
                                {item.image_url ? (
                                    <img src={`${BASE_UPLOAD_URL}/${item.image_url.replace(/^\/+/, '')}`} alt={item.model_name} className="w-8 h-8 object-cover rounded bg-stone-700" />
                                ) : (
                                    <div className="w-8 h-8 rounded bg-stone-700 flex items-center justify-center text-xs text-stone-500">
                                        No Img
                                    </div>
                                )}
                                <span className="text-stone-200 font-medium text-sm">{item.model_name}</span>
                            </div>
                            <button
                                onClick={() => setSelectedAccessory(item)}
                                className="text-stone-500 hover:text-stone-300"
                            >
                                <Info size={16} />
                            </button>
                        </div>
                    ))
                )}
            </div>

            <AccessoryDetailsModal
                isOpen={!!selectedAccessory}
                onClose={() => setSelectedAccessory(null)}
                accessory={selectedAccessory}
            />
        </div>
    );
};

export default PackageContentsPanel;
